/* SearchTypeRenderer.js */

"use strict";

class SearchTypeColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("search-type-column");
        this._rootElem.component = this._model;

        this._statusIcon = document.createElement("base-icon-gl");

        this._registerListeners();
        this.render();
    }

    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _shutdown() {
        return new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();

            this._statusIcon.remove();
            this._statusIcon = undefined;

            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
    }

    _registerListeners() {
        this._model.on("SearchType", (this._onSearchType = this._onSearchType.bind(this)));
    }

    _unregisterListeners() {
        this._model.removeAllListeners("SearchType");
    }

    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/

    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */

    render() {
        this._setSearchType(this._model.getSearchType());
        return Promise.resolve();
    }

    get rootElement() {
        return this.getRootElement();
    }

    getRootElement() {
        return this._rootElem;
    }

    get model() {
        return this.getModel();
    }

    getModel() {
        return this._model;
    }

    /*******************************************/
    /* END COMPONENT RENDERER METHODS          */
    /* START HANDLER METHODS                   */
    /*******************************************/

    _onSearchType(newVal) {
        this._setSearchType(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE API METHODS               */
    /*******************************************/

    _setSearchType(newVal) {
        const val = this._model._context[newVal] || "";
        this._rootElem.innerHTML = val;
    }

    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /*******************************************/
}

module.exports = SearchTypeColumnRenderer;
